import React, { useState, useEffect } from 'react';
import { validateNamespaceFromApi } from '../services/service'; // Ajuste o caminho conforme sua estrutura


const NamespaceSelector = () => {
  const [namespace, setNamespace] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [savedNamespaces, setSavedNamespaces] = useState([]);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    // Carregar namespaces salvos do localStorage
    try {
      const saved = localStorage.getItem('kds_namespaces');
      if (saved) {
        setSavedNamespaces(JSON.parse(saved));
      }
    } catch (error) {
      console.warn('Erro ao carregar namespaces salvos:', error);
    }
  }, []);

  const saveNamespace = (ns) => {
    try {
      const current = savedNamespaces.filter(item => item !== ns);
      const updated = [ns, ...current].slice(0, 10); // Manter apenas os 10 mais recentes
      setSavedNamespaces(updated);
      localStorage.setItem('kds_namespaces', JSON.stringify(updated));
    } catch (error) {
      console.warn('Erro ao salvar namespace:', error);
    }
  };

  const validateNamespace = async (ns) => {
    const result = await validateNamespaceFromApi(ns);
    return result.success;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!namespace.trim()) return;

    setIsLoading(true);
    setError('');
    const cleanNamespace = namespace.trim().toLowerCase();

    try {
      // Validar namespace com a API
      const isValid = await validateNamespace(cleanNamespace);

      if (isValid) {
        // Salvar namespace nos recentes
        saveNamespace(cleanNamespace);

        // Redirecionar para a URL com namespace
        window.location.href = `/${cleanNamespace}`;
      } else {
        setError('Namespace não foi localizado. Verifique se o nome está correto.');
        setIsLoading(false);
      }
    } catch (error) {
      setError('Erro ao validar namespace. Tente novamente.');
      setIsLoading(false);
    }
  };

  const handleNamespaceClick = async (ns) => {
    setIsLoading(true);
    setError('');

    try {
      // Validar namespace com a API
      const isValid = await validateNamespace(ns);

      if (isValid) {
        window.location.href = `/${ns}`;
      } else {
        setError('Namespace não foi localizado. Verifique se o nome está correto.');
        setIsLoading(false);
      }
    } catch (error) {
      setError('Erro ao validar namespace. Tente novamente.');
      setIsLoading(false);
    }
  };

  const removeNamespace = (nsToRemove, e) => {
    e.stopPropagation(); // não dispara o click do pai
    const updated = savedNamespaces.filter(ns => ns !== nsToRemove);
    setSavedNamespaces(updated);
    // atualiza o localStorage
    localStorage.setItem('kds_namespaces', JSON.stringify(updated));
  };

  const clearError = () => {
    setError('');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-xl p-8">
        {/* Logo */}
        <div className="text-center mb-4">
          <img
            src="https://download.softhubs.com.br/files/LOGO/kds-softcom.png"
            alt="Softcom Tecnologia"
            className="h-12 w-auto object-contain mx-auto mb-4"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
          <p className="text-gray-600">Sistema de Monitoramento de Cozinha</p>
        </div>

        {/* Formulário */}
        <div className="space-y-6">
          <div>
            <label htmlFor="namespace" className="block text-sm font-medium text-gray-700 mb-2">
              Informe o Namespace da Empresa
            </label>
            <input
              id="namespace"
              type="text"
              value={namespace}
              onChange={(e) => {
                setNamespace(e.target.value);
                if (error) clearError(); // Limpar erro quando usuário digitar
              }}
              onKeyPress={(e) => e.key === 'Enter' && handleSubmit(e)}
              placeholder="Ex: matriz, filial1, empresa..."
              className="w-full px-4 py-3 border border-gray-300 rounded-lg outline-none transition-all"
              style={{
                borderColor: error ? '#ef4444' : (namespace ? '#F1B40B' : '#d1d5db'),
                boxShadow: error ? '0 0 0 2px rgba(239, 68, 68, 0.2)' : (namespace ? '0 0 0 2px rgba(241, 180, 11, 0.2)' : 'none')
              }}
              disabled={isLoading}
              autoFocus
            />
            {error && (
              <p className="text-sm text-red-600 mt-1 flex items-center gap-1">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
                {error}
              </p>
            )}
            {!error && (
              <p className="text-xs text-gray-500 mt-1">
                Será redirecionado para: <span className="font-mono">/{namespace || 'namespace'}</span>
              </p>
            )}
          </div>

          <button
            onClick={handleSubmit}
            disabled={!namespace.trim() || isLoading}
            className="w-full text-white py-3 px-4 rounded-lg font-medium focus:ring-2 focus:ring-offset-2 disabled:cursor-not-allowed transition-all duration-200 flex items-center justify-center"
            style={{
              backgroundColor: '#F1B40B',
              opacity: (!namespace.trim() || isLoading) ? 0.5 : 1,
              boxShadow: '0 0 0 2px rgba(241, 180, 11, 0.2)'
            }}
            onMouseEnter={(e) => {
              if (!isLoading && namespace.trim()) {
                e.target.style.backgroundColor = '#E6A809';
              }
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#F1B40B';
            }}
          >
            {isLoading ? (
              <>
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                Validando...
              </>
            ) : (
              'Validar e Acessar'
            )}
          </button>
        </div>

        {/* Namespaces Recentes */}
        {savedNamespaces.length > 0 && (
          <div className="mt-8 pt-6 border-t border-gray-200">
            <h3 className="text-sm font-medium text-gray-700 mb-3">Acessos Recentes</h3>
            <div className="space-y-2">
              {savedNamespaces.map((ns, index) => (
                <div
                  key={index}
                  className="w-full px-3 py-2 text-sm bg-gray-50 rounded-lg transition-colors flex items-center justify-between group"
                  style={{
                    backgroundColor: hoveredItem === index ? 'rgba(253, 216, 0, 0.1)' : '#f9fafb'
                  }}
                  onMouseEnter={() => setHoveredItem(index)}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <button
                    onClick={() => handleNamespaceClick(ns)}
                    disabled={isLoading}
                    className="flex-1 text-left flex items-center justify-between disabled:opacity-50"
                  >
                    <span className="font-mono text-gray-700">{ns}</span>
                    <svg
                      className="w-4 h-4 transition-colors"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      style={{
                        color: hoveredItem === index ? '#F1B40B' : '#9ca3af'
                      }}
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                  <button
                    onClick={(e) => removeNamespace(ns, e)}
                    className="ml-2 p-1 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded transition-colors"
                    title="Remover"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Informações */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <div className="text-xs text-gray-500 space-y-1">
            <p className="flex items-center gap-1">
              <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
              O namespace identifica sua empresa no sistema
            </p>
            <p className="flex items-center gap-1">
              <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
              </svg>
              Use apenas letras, números e hífen
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NamespaceSelector;